"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.epsilon");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NumberUtils =
/*#__PURE__*/
function () {
  function NumberUtils() {
    _classCallCheck(this, NumberUtils);
  }

  _createClass(NumberUtils, null, [{
    key: "round",
    value: function round(n) {
      var fractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var multiplier = Math.pow(10, fractionDigits);
      return Math.round((n + Number.EPSILON) * multiplier) / multiplier;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(n) {
      var fractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var rounded = NumberUtils.round(n, fractionDigits);
      return rounded.toLocaleString('ru-RU');
    }
  }]);

  return NumberUtils;
}();

exports.default = NumberUtils;